@if (isFilterVisible$ | async) {
  <div class="content-filter-container flex flex-center-center">
    <div class="flex flex-start-center gap-12">
      <div>Sorting:</div>
      @if (sortingMode$ | async; as sortingMode) {
        <mat-button-toggle-group (change)="sortingModeUpdated($event)" aria-label="Content mode" name="sortingMode">
          <mat-button-toggle
            [checked]="sortingMode === CmsSortingModes.NewestFirst"
            [disableRipple]="true"
            [value]="CmsSortingModes.NewestFirst"
            color="primary"
          >
            Newest first
          </mat-button-toggle>
          <mat-button-toggle
            [checked]="sortingMode === CmsSortingModes.OldestFirst"
            [disableRipple]="true"
            [value]="CmsSortingModes.OldestFirst"
            color="primary"
          >
            Oldest first
          </mat-button-toggle>
        </mat-button-toggle-group>
      }
    </div>
  </div>
}
<div class="cards-container">
  @for (card of cardsList; track trackByCardId(i, card); let i = $index) {
    <cms-card [details]="card"></cms-card>
  }
</div>
